import { VideoTileStylesProps } from '@azure/communication-react';
import { IStyle, memoizeFunction, mergeStyles } from '@fluentui/react';

const localPreviewContainerStyle: IStyle = {
  borderRadius: '.25rem'
};

export const localPreviewContainerStyleDesktop = mergeStyles({
  ...localPreviewContainerStyle,
  minWidth: '11rem',
  minHeight: '18.75rem',  //spare case for the browsers not supporting "aspect-ratio"
  padding: '0.5rem'
});

export const localPreviewContainerStyleMobile = mergeStyles({
  ...localPreviewContainerStyle,
  width: '100%',
  height: '100%'
});

export const cameraOffLabelStyle = mergeStyles({
  fontSize: '0.75rem' // 12px
});

export const getLocalPreviewTileStyle = memoizeFunction((scalingMode: 'Crop'|'Fit' = 'Fit'): VideoTileStylesProps =>
  ({
    root: {
      ...(scalingMode === 'Crop' ? {
        flexGrow: 1,
      } : {}),
      aspectRatio: '16/9',
      borderRadius: '.25rem',
      '@media (forced-colors: active)': {
        borderColor: '#FFFFFF',
        border: '1px solid'
      }
    },
    videoContainer: {
      video: {
        objectFit: scalingMode === 'Crop' ? 'cover !important' : 'contain !important'
      }
    }
  })
);
